<template>
  <span>
    <span class="v-rating" v-for="level in [1,2,3,4,5]" :key="level" @click="changeValue(level)">
      <starSVG :class="getClassName(level)" />
    </span>
  </span>
</template>
<script>
// import _ from "lodash";
import isInteger from "lodash/isInteger";
import starSVG from "@/views/SVG/starSVG";
export default {
  props: ["rating", "clickable"],
  data() {
    return {
      star_value: this.rating
    };
  },
  watch: {
    rating: {
      handler(newValue) {
        if (newValue) {
          this.star_value = newValue;
        }
      }
    }
  },
  components: {
    starSVG
  },
  watch: {
    rating: function(val) {
      this.star_value = val;
    }
  },
  methods: {
    getClassName(level) {
      let rating = Number(this.star_value);

      if (level < rating + 1) {
        if (Math.floor(rating) >= level) {
          return "active";
        } else {
          if (!isInteger(rating)) {
            return "half-active";
          } else {
            return "active";
          }
        }
      }
      return "";
    },
    changeValue(value) {
      if (!this.clickable) {
        return;
      }
      //this.star_value = value;
      //this.$emit("input", value);
    }
  }
};
</script>
